module.exports = __webpack_public_path__ + "img/farming_18.b99cb720.png";